export default {
  "header": {
    "title": {
      "customer-info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isi Data Pelanggan"])},
      "payment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bayar"])}
    },
    "date-selection": {
      "date-condition": {
        "today": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hari ini"])},
        "tommorow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Besok"])}
      },
      "not-selected": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belum dipilih"])},
      "change-date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ubah Tanggal"])},
      "dialog": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilih Tanggal Tiket"])},
        "pick-date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilih Tanggal"])}
      }
    },
    "change-ticket": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ubah Tiket"])},
    "step": {
      "choose-ticket": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilih Tiket"])},
      "fill-data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isi Data"])},
      "pay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bayar"])},
      "done": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selesai"])}
    },
    "language": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bahasa"])}
  },
  "footer": {
    "powered-by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dikembangkan oleh"])}
  },
  "product-preview": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategori Tiket"])},
    "subtotal": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Subtotal (", _interpolate(_named("n")), " tiket)"])}
  },
  "customer-info": {
    "general": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informasi Pelanggan"])},
      "input": {
        "answer": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Masukkan jawaban"])}
        },
        "email": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email untuk pengiriman tiket & invoice"])}
        },
        "retype-email": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ketik Ulang Email"])}
        },
        "hp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nomor WhatsApp"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nomor WhatsApp untuk pengiriman tiket & invoice"])}
        },
        "fullname": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nama Lengkap"])}
        },
        "identity-card": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No. Kartu Identitas"])}
        },
        "toc": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saya setuju dengan"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Syarat & Ketentuan"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["yang berlaku di etix.co.id"])}
        ],
        "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Simpan"])},
        "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ubah"])}
      },
      "rules": {
        "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kamu perlu mengisi bagian ini"])},
        "email": {
          "valid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tolong masukkan alamat email yang benar"])},
          "retype": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tolong masukkan ulang alamat email yang benar"])}
        },
        "hp": {
          "valid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tolong masukkan nomor WhatsApp yang benar"])},
          "digit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nomor WhatsApp terdiri atas minimal 10 digit"])}
        },
        "identity-card": {
          "valid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tolong masukkan nomor kartu identitas yang benar"])}
        },
        "toc": {
          "agree": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kamu harus menyetujui untuk melanjutkan"])}
        },
        "radio-field": {
          "valid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Silahkan pilih salah satu opsi"])}
        },
        "checkbox-field": {
          "valid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilih semua yang berlaku"])}
        }
      },
      "save-dialog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informasi pelanggan tersimpan, silahkan klik lanjutkan"])},
      "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kembali"])},
      "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Simpan"])}
    },
    "race": {
      "contact": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informasi Kontak"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bukti dan konfirmasi pendaftaran akan dikirimkan ke detail informasi kontak yang tertera di sini"])},
        "input": {
          "fullname": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nama Lengkap"])}
          },
          "email": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
          },
          "hp": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nomor WhatsApp"])}
          },
          "address": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alamat Lengkap"])}
          },
          "province": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Provinsi"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilih Provinsi domisili Anda"])}
          },
          "city": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kota/Kabupaten"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilih Kota/Kabupaten domisili Anda"])}
          },
          "region": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Warga Negara"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilih Warga Negara Anda"])}
          },
          "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Simpan"])},
          "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ubah"])}
        },
        "save-dialog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informasi pelanggan tersimpan, silahkan klik lanjutkan"])}
      },
      "participants": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detail Peserta"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bukti dan konfirmasi pendaftaran akan dikirimkan ke detail informasi kontak yang tertera di sini"])},
        "input": {
          "first-name": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nama Depan"])}
          },
          "last-name": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nama Belakang"])}
          },
          "bib-name": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nama BIB"])}
          },
          "identity-card": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No. Kartu Identitas/No. Paspor"])}
          },
          "blood-type": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Golongan Darah"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilih golongan darah"])}
          },
          "gender": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jenis Kelamin"])},
            "male": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pria"])},
            "female": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wanita"])}
          },
          "date-of-birth": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tanggal Lahir"])},
            "age": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Umur"])},
            "years": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("n")), " tahun"])},
            "months": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([" ", _interpolate(_named("n")), " bulan dari tanggal acara"])}
          },
          "size-shirt": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ukuran Kaos"])}
          },
          "medical-condition": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kondisi Kesehatan"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tulis kondisi medis/sakit yang Anda alami"])}
          },
          "is_checkup": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apakah Anda sudah melakukan medical check up dalam 3 bulan terakhir?"])},
            "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ya"])},
            "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tidak"])}
          },
          "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Simpan"])},
          "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ubah"])}
        }
      },
      "emergency": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontak Darurat"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isi informasi kontak darurat yang bisa dihubungi"])},
        "input": {
          "fullname": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nama Lengkap"])}
          },
          "hp": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nomor WhatsApp"])}
          },
          "relation": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubungan/Relasi"])},
            "options": {
              "sibling": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saudara"])},
              "husbandwife": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suami / Istri"])},
              "parent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Orang Tua"])},
              "friend": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teman"])},
              "other": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lainnya"])}
            }
          },
          "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Simpan"])},
          "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ubah"])}
        }
      },
      "toc": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saya setuju dengan"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Syarat & Ketentuan"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["yang berlaku di etix.co.id"])}
      ],
      "rules": {
        "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kamu perlu mengisi bagian ini"])},
        "email": {
          "valid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tolong masukkan alamat email yang benar"])}
        },
        "hp": {
          "valid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tolong masukkan nomor WhatsApp yang benar"])},
          "digit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nomor WhatsApp terdiri atas minimal 10 digit"])}
        },
        "toc": {
          "agree": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kamu harus menyetujui untuk melanjutkan"])}
        },
        "bib": {
          "digit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nama BIB terdiri atas maksimal 8 karakter"])}
        }
      }
    }
  },
  "payment-product": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilih Metode Pembayaran"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data dirimu akan digunakan ketika verifikasi tiket dan pendataan kepada pihak penyelenggara"])},
    "free": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terima kasih, Anda tidak perlu membayar biaya apapun. Silahkan klik bayar untuk melanjutkan"])}
  },
  "cart-detail": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pesananmu"])},
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tiket yang kamu pilih akan tampil disini"])},
    "ticket-qty": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("n")), " tiket"])},
    "subtotal": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SUBTOTAL"])},
    "service-fee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biaya Platform"])},
    "ticket-fee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biaya Tiket"])},
    "payment-fee-desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belum termasuk biaya transaksi"])},
    "payment-fee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biaya Transaksi"])},
    "payment-method": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metode Pembayaran"])},
    "total-purchase": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TOTAL BELANJA"])},
    "total-tickets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TOTAL HARGA TIKET"])},
    "discount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Diskon"])},
    "free": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gratis"])},
    "max-ticket-warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maksimal Pembelian 20 Tiket"])},
    "redeem-voucher": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gunakan Voucher"])},
    "send-whatsapp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirim ke WhatsApp"])},
    "button": {
      "continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lanjutkan"])},
      "pay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bayar"])},
      "payment-page": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buka Halaman Pembayaran"])},
      "payment-status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status Pembayaran"])},
      "edit-data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ubah Data"])}
    },
    "payment-status": {
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transaksimu Berhasil!"])},
      "success-message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kami telah mengirimkan tiketmu dalam bentuk e-voucher ke emailmu. Yuk, cek dulu!"])},
      "expired": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transaksimu Expired!"])},
      "expired-message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pembayaran expired. Silahkan melakukan pembelian ulang setelah halaman ini!"])},
      "process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pembayaran sedang dalam proses"])},
      "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Halaman ini akan tertutup dalam 5 detik dan kamu akan kami alihkan ke halaman awal."])},
      "countdown": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("n")), " detik"])},
      "save-message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mohon Simpan Kode Transaksi Dibawah Ini"])},
      "transaction-id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transaction ID: "])},
      "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lanjut"])}
    },
    "order-failed": {
      "max-order": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pesananmu melewati batas maksimal pembelian"])},
      "min-order": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pesananmu belum mencukupi batas minimal pembelian"])},
      "non-active-product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Produk tidak ditemukan"])},
      "store-missmatch": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store tidak sesuai"])},
      "product-type-missmatch": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tiket produk tidak sesuai"])},
      "out-of-stock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maaf, produk yang ingin kamu beli telah habis"])},
      "limit-order-exceed": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Maaf, kamu tidak dapat membeli produk ini karena limitasi pembelian ", _interpolate(_named("n")), " tiket"])},
      "price-changed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maaf, ada perubahan harga untuk tiket ini. Silahkan cek kembali sebelum melanjutkan pembayaran"])},
      "discount-changed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops, ada perubahan diskon untuk tiket ini. Yuk, cek lagi sebelum lanjut ke pembayaran"])},
      "voucher-not-found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gagal memasang kupon/voucher"])},
      "product-not-found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops, produk ini sudah nggak aktif lagi. Yuk, coba cek produk lain yang masih ada"])},
      "product-type-not-found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops, tiket ini sudah nggak aktif lagi. Yuk, coba cek tiket lain yang masih ada"])},
      "payment-method-not-allowed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metode pembayaran ini tidak diizinkan. Silahkan pilih metode pembayaran lainnya."])},
      "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order gagal"])}
    }
  },
  "dialog-confirmation": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konfirmasi"])},
    "subtitle-1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ringkasan Data Tiket"])},
    "subtitle-2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detail Pembayaran"])},
    "contact-information": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informasi Kontak"])},
    "customer-detail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detail Peserta"])},
    "bib-name": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Nama BIB: ", _interpolate(_named("name"))])},
    "emergency-contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontak Darurat"])},
    "ticket-qty": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("n")), " tiket"])},
    "subtotal": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SUBTOTAL"])},
    "service-fee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biaya Platform"])},
    "ticket-fee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biaya Tiket"])},
    "payment-fee-desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belum termasuk biaya transaksi"])},
    "payment-fee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biaya Transaksi"])},
    "payment-method": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metode Pembayaran"])},
    "total-purchase": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TOTAL BELANJA"])},
    "total-tickets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TOTAL TIKET"])},
    "discount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Diskon"])},
    "free": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gratis"])},
    "information": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data yang sudah diisi tidak dapat diubah ketika sudah melakukan pembayaran!"])},
    "button": {
      "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ubah"])},
      "continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setuju dan Lanjutkan"])},
      "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Simpan"])}
    }
  },
  "event-card": {
    "time": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Jam acara: ", _interpolate(_named("time"))])},
    "pullout-date": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Penjualan tiket berakhir pada ", _interpolate(_named("date"))])},
    "remaining-tickets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisa Tiket"])},
    "out-of-stock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stok Habis"])},
    "almost-out-of-stock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hampir Habis"])},
    "pullout-end": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Penjualan Berakhir"])},
    "choose-ticket": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilih Tiket"])},
    "ticket-qty": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("n")), " tiket"])},
    "max-race-ticket": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Minimal pembelian tiket ini melebihi batas. Maksimal pembelian ", _interpolate(_named("n")), " tiket dalam 1 transaksi"])},
    "ticket-validation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tiket berlaku untuk"])},
    "validation-dates": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("day")), " Hari"])}
  },
  "non-event-card": {
    "day": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("day"))])},
    "expiry": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([" Berlaku ", _interpolate(_named("n")), " hari setelah tiket dibayar"])},
    "remaining-tickets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisa Tiket"])},
    "out-of-stock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stok Habis"])},
    "almost-out-of-stock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hampir Habis"])},
    "pullout-end": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Penjualan Berakhir"])},
    "choose-ticket": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilih Tiket"])}
  },
  "error": {
    "not-found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maaf, Kami Tidak Menemukan Yang Kamu Cari"])},
    "service-error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maaf, Ada Kesalahan Server"])},
    "unknown": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maaf, Terjadi Gangguan"])}
  }
}